import Grid from '@mui/material/Grid2';
import { DetailsGrid } from '../DetailsGrid';
import { useAssemblyData } from '../hooks/useAssemblyData';
import { useGetGenericDetailsPanels } from '../hooks/useGetGenericDetailsPanels';
import { useFieldFormatting } from '../hooks/useFieldFormatting';
import { OverviewAccordion } from '../ComponentsOverview/OverviewAccordion';
import Stack from '@mui/material/Stack';

export const AssessmentDetailsSection = ({ assemblyId }: { assemblyId?: string }) => {
  const { assemblyDetails, assemblyArea } = useAssemblyData({ assemblyId });
  const { getFieldName, getFormattedValueDetails } = useFieldFormatting(
    assemblyDetails,
    assemblyArea
  );
  const { detailsData, displayableFields } = useGetGenericDetailsPanels(assemblyDetails);

  return (
    <Stack direction="column" gap="2rem" sx={{ width: '100%' }}>
      {assemblyDetails &&
        detailsData &&
        detailsData.map((detail) => (
          <OverviewAccordion
            key={detail.title}
            title={detail.title}
            details={
              <Grid container spacing="2.6rem" sx={{ width: '100%', p: '4rem', pt: '1.4rem' }}>
                <DetailsGrid
                  title=""
                  data={detail.data}
                  getFieldName={getFieldName}
                  getFormattedValue={getFormattedValueDetails}
                  displayableFields={displayableFields}
                />
              </Grid>
            }
            defaultExpanded={detail.data.length > 0}
          />
        ))}
    </Stack>
  );
};
